export default "__VITE_ASSET__ChprxaEJ__"